<template>
  <div class="main" >
    <no-access v-if="noAccess" />
    <div v-else class="header" ref="headerWidget" >
      <div v-if="headerWidget" >
        <widget
           :widget="headerWidget"
           :header="true"
           @delete="deleteHeaderWidget" />
      </div>
    </div>

    <div v-if="!noAccess" class="board" >
      <div :class="{divided: isEdit}" >
        <div :class="{'left-panel': isEdit}" >
          <portal
             class="portal"
             :id="id"
             :autoSize="true"
             :disableToolbox="emptyToolbox"
             :verticalCompact="true" >
            <template slot="widget" slot-scope="props" >
              <widget :widget="props.widget" @delete="props.delete" />
            </template>
            <template slot="toolbox" slot-scope="props" >
              <portal-toolbox
                 v-model="emptyToolbox"
                 @newWidget="props.addWidget"
                 @reload="props.reload" />
            </template>
          </portal>
        </div>

        <div class="right-panel" >
          <component
             v-if="isEdit"
             class="editable"
             :is="editComponent"
             :title.sync="editable.title"
             :graph.sync="editable.graph"
             :id="editable.id"
             :noEmpty.sync="editable.noEmpty"
             :limit.sync="editable.limit"
             :limitStrict.sync="editable.limitStrict"
             :legendPageSize.sync="editable.legendPageSize"
             :colorScheme.sync="editable.colorScheme"
             :formats.sync="editable.formats"
             :advanced.sync="editable.advanced"
             :specialConfig.sync="editable.specialConfig"
             :measures="editable.measures"
             :measure.sync="editable.measure"
             :dimensions="editable.dimensions"
             :dimension.sync="editable.dimension"
             :filter.sync="editable.filter"
             :filters.sync="editable.filters"
             :viewsConfig.sync="editable.viewsConfig"
             :style="{ top: headerHeight + 'px' }"
             @save="saveEditable"
             @update:filter="updateFilter"
             :display="display" />
        </div>
      </div>
      <div class="dummy-bottom" />
    </div>
  </div>
</template>

<style scoped>
.portal.editing >>> h1 {
    display: block;
}
.portal >>> h1 {
    display: none;
}
.main {
    display: flex;
    flex-direction: column;
}
.divided {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}
.divided .left-panel {
    width: 75%;
}
.divided .right-panel {
    width: 23%;
    min-height: 110%;
}
.divided .right-panel .editable{
    position: sticky;
    top: 0;
}
.portal >>> .vue-grid-layout {
    overflow: visible;
}
.el-tabs {
    margin-left: 15px;
}
.el-tabs >>> .el-tabs__item {
    color: #8391a5;
}
.el-tabs >>> .el-tabs__item.is-active {
    color: #409eff;
}
.portal >>> .toolbox {
    z-index: 2013;
}
.header {
    position: sticky;
    top: 0;
    z-index: 999;
}
.dummy-bottom {
    height: 100px;
    min-height: 100px;
    display: block;
}
.right-panel >>> .el-form-item {
    margin-bottom: 0;
}
.right-panel >>> .el-collapse-item__header {
    height: 35px;
    line-height : 35px;
}
.right-panel >>> .el-collapse-item__content {
    padding-bottom: 0;
}
</style>

<script>
import Portal from 'macarons/src/components/Portal.vue'
import Widget from './Widget.vue'
import PortalToolbox from './PortalToolbox.vue'
import GraphBus from 'macarons-graphs-front/src/events'
import {api} from 'macarons'
import NoAccess from './components/NoAccess'

export default {
  props: {
    id: {
      default: null
    }
  },
  components: {
    Portal,
    Widget,
    PortalToolbox,
    NoAccess
  },
  data () {
    return {
      activeName: null,
      oldBoards: [],
      editComponent: null,
      editable: null,
      emptyToolbox: true,
      headerHeight: 0,
      noAccess: true
    }
  },
  watch: {
    globalFilters: {
      immediate: true,
      handler () {
        this.noAccess = true
        this.$store.dispatch('getBoardAccess', this.board.id).then(access => {
          if (!access) {
            console.log(this.$router.currentRoute.name)
            if (this.$router.currentRoute.name === 'home-board') {
              this.noAccess = true
            } else {
              this.noAccess = false
              this.$router.push('/home')
            }
          } else {
            this.noAccess = false
            if (this.$router.currentRoute.name === 'home-board') {
              this.$router.push('/boards/' + this.board.id)
            }
          }
        })
      }
    }
  },
  mounted () {
    GraphBus.$on('graph:edit', this.onEdit)
    GraphBus.$on('graph:cancel', this.onCancel)
  },
  destroyed () {
    GraphBus.$off('graph:edit', this.onEdit)
    GraphBus.$off('graph:cancel', this.onCancel)
  },
  computed: {
    globalFilters () {
      return this.$store.state.chloe.globalFilters
    },
    headerWidget () {
      if (!this.board) {
        return null
      }
      const widget = this.board.widgets.find(w => w.isHeaderWidget)
      if (!widget) {
        return null
      }
      return Object.assign({
        props: {allowResize: false, allowDrag: false, dragAllowFrom: false}
      }, widget)
    },
    board () {
      return this.$store.state.board
    },
    isEdit () {
      return Boolean(this.editable && this.editComponent)
    },
    display () {
      return {
        container: {
          name: 'el-collapse',
          accordion: true
        },
        item: {
          name: 'el-collapse-item'
        }
      }
    }
  },
  methods: {
    deleteHeaderWidget (widget) {
      api.get('board/' + this.board.id).then(({data}) => {
        return this.$store.dispatch('updateBoard', {
          name: data.name,
          headerWidget: null
        })
      })
    },
    updateFilter (filter) {
      if (typeof this.editable.updateFilters === 'function') {
        filter.forEach(f => {
          this.editable.updateFilters({
            dimension: f.value.UniqueName,
            values: f.defaultValues
          })
        })
      }
    },
    onEdit (editComponent, editable) {
      editable.$parent.$el.scrollIntoView({behavior: 'smooth'})
      if (this.isEdit) {
        this.editable.cancel()
        this.$nextTick(() => {
          this.edit(editComponent, editable)
        })
      } else {
        this.edit(editComponent, editable)
      }
    },
    onCancel () {
      this.edit()
      this.$nextTick(this.doLayout)
    },
    edit (editComponent, editable) {
      this.editComponent = editComponent
      this.editable = editable
      this.$nextTick(() => {
        this.doLayout()
        this.headerHeight = this.$refs.headerWidget.getBoundingClientRect().height
      })
    },
    saveEditable () {
      this.editable.save().then(() => {
        this.$nextTick(this.doLayout)
      })
    },
    doLayout () {
      window.dispatchEvent(new Event('resize'))
    }
  }
}
</script>

<style lang="less">
.divided .right-panel .editable {
  .el-carousel__mask,
  .el-cascader-menu,
  .el-cascader-menu__item.is-disabled:hover,
  .el-collapse-item__wrap {
    background-color: transparent;
  }
  .el-input, .el-select {
    display: block;
    margin: 0.4em;
  }
}
</style>



// WEBPACK FOOTER //
// src/macarons/Board.vue